import LoincRepository from "@/repositories/loinc/LoincRepository";
import importCSV from '@/storages/loinc/ImportCSVStore';
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'loinc',
    namespaced: true,
    state: {
        ...makeState(),
        synonyms: [],
        langs: [],
        status: [],
        order_observations: []
    },
    getters: {
        ...makeGetters(),
        getSynonyms(state) {
            return state.synonyms
        },
        getLangs(state) {
            return state.langs
        },
        getStatusOptions(state) {
            return state.status
        },
        getOrderObsOptions(state) {
            return state.order_observations
        },
    },
    mutations: {
        ...makeMutations(),
        setSynonyms(state, array) {
            state.synonyms = array
        },
        setLangs(state, array) {
            state.langs = array
        },
        setStatusOptions(state, array) {
            state.status = array
        },
        setOrderObsOptions(state, array) {
            state.order_observations = array
        },
    },
    actions: {
        async listOne({commit, state}, id) {
            commit('setLoading', true)
            await LoincRepository.fetch(id).then(response => {
                commit('setCurrent', response.data)
            })
            commit('setLoading', false)
        },
        async listAll({commit, state}, params) {
            commit('setLoading', true)
            await LoincRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', {
                    per_page: parseInt(response.data.per_page),
                    page: response.data.current_page,
                    total: response.data.total
                })
            })
            commit('setLoading', false)
        },
        async listSynonyms({commit, state}, loinc) {
            await LoincRepository.fetchSynonyms(loinc).then(response => {
                commit('setSynonyms', response.data.data)
            })
        },
        async listLangs({commit, state}, loinc) {
            await LoincRepository.fetchLangs(loinc).then(response => {
                commit('setLangs', response.data.data)
            })
        },
        async listOptions({commit, state}, params) {
            await LoincRepository.fetchStatusOptions(params).then(response => {
                commit('setStatusOptions', response.data.data.options)
            })
            await LoincRepository.fetchOrderObsOptions(params).then(response => {
                commit('setOrderObsOptions', response.data.data.options)
            })
        }
    },
    modules: {
        importCSV
    }
}
